import __vue_component__ from './HseInput.vue.js';
import __vue_component__$1 from './HseTextArea.vue.js';

//

/**
 * @storybook /?path=/story/inputs-input--rich-input
 * @react /src-components-rich-input
 * @reactStorybook /?path=/story/inputs-input--rich-input
 * @hideSlot default
 * @slot error-message Слот сообщения ошибки
 * @slot hint Слот подсказки
 */
var script = {
  name: 'HseRichInput',
  inheritAttrs: false,
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    /**
     * Дополнительные классы элементов
     * - component – класс компонента из пропа `component`
     * - label – лейбл
     * - message - сообщение (`hint` или `errorMessage`)
     */
    classes: {
      type: Object,
      default: () => ({
        component: '',
        label: '',
        message: ''
      })
    },
    /**
     * Текущее значение
     */
    value: {
      type: [String, Array, Object],
      default: ''
    },
    /**
     * Сообщение ошибки
     */
    errorMessage: {
      type: String,
      default: ''
    },
    /**
     * Подсказка
     */
    hint: {
      type: String,
      default: ''
    },
    /**
     * Лейбл
     */
    label: {
      type: String,
      default: ''
    },
    /**
     * Компонент
     */
    component: {
      type: [String, Object, Function],
      default: () => __vue_component__
    }
  },
  computed: {
    tag() {
      switch (this.component) {
        case 'textarea':
          return __vue_component__$1;
        case 'input':
          return __vue_component__;
        default:
          return this.component;
      }
    },
    hasError() {
      return this.errorMessage || this.$slots['error-message'];
    },
    hasHint() {
      return this.hint || this.$slots.hint;
    },
    hasMessage() {
      return this.hasHint || this.hasError;
    },
    messageSlotName() {
      return this.$slots['error-message'] ? 'error-message' : 'hint';
    }
  }
};

export default script;
